module.exports = __webpack_public_path__ + "static/media/QNB.ef81d443.svg";